<template>
  <CloseCircleButtonModal
    class="shipping-info-modal"
    title-text="発送について"
    @clicked-modal-cover="onClickModalCover"
    @clicked-close="onClickCloseButton"
  >
    <div class="shipping-info-modal__content">
      <ItemDescriptionMailSlotDeliverable
        v-if="mailSlotDeliverable"
        class="shipping-info-modal__mail-slot"
      />

      <NoticeArea
        v-if="hasNoticeContent"
        class="shipping-info-modal__notice"
        :notice-detail="noticeDetail"
        :is-shipping-info-modal="true"
      />
    </div>
  </CloseCircleButtonModal>
</template>

<script>
import CloseCircleButtonModal from '../../../../molecules/modals/CloseCircleButtonModal.vue'
import ItemDescriptionMailSlotDeliverable from '../../../../atoms/item_descriptions/ItemDescriptionMailSlotDeliverable.vue'
import NoticeArea from '../../../../molecules/items/NoticeArea.vue'

export default {
  name: 'ShippingInfoModal',
  components: {
    CloseCircleButtonModal,
    ItemDescriptionMailSlotDeliverable,
    NoticeArea
  },
  props: {
    mailSlotDeliverable: {
      type: Boolean,
      required: false,
      default: false
    },
    noticeDetail: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    hasNoticeContent() {
      return this.noticeDetail !== null
    }
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickCloseButton() {
      this.$emit('clicked-close')
    }
  }
}
</script>

<style lang="scss" scoped>
.shipping-info-modal {
  :deep(.close-circle-button-modal__content) {
    max-height: calc(100vh - 96px);
    max-width: 736px;

    @media all and (max-width: ($base-contents-width - 32)) {
      max-width: calc(100vw - 32px);
    }
  }

  :deep(.close-circle-button-modal__body) {
    overflow-y: auto;
  }
}

.shipping-info-modal__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.shipping-info-modal__mail-slot {
  margin-top: 0;
}

.shipping-info-modal__notice {
  margin: 0;
  background-color: transparent;

  :deep(.items-show__item-notice-wrapper) {
    margin: 0;
    background-color: transparent;
  }

  :deep(.items-show__item-notice-content) {
    padding-bottom: 0;
    max-width: none;
  }

  :deep(.notice-area__body) {
    padding: 0;
  }

  :deep(.notice-area) {
    :deep(.decoration-head) {
      display: none;
    }
  }
}
</style>
